import React, { useEffect, useState } from "react";
import { Download } from "lucide-react";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle,
} from "@/components/ui/dialog";

export default function InstallButton() {
  const [deferred, setDeferred] = useState(null);
  const [showHelp, setShowHelp] = useState(false);
  const [installed, setInstalled] = useState(false);

  useEffect(() => {
    const onPrompt = (e) => { e.preventDefault(); setDeferred(e); };
    const onInstalled = () => setInstalled(true);
    window.addEventListener("beforeinstallprompt", onPrompt);
    window.addEventListener("appinstalled", onInstalled);
    if (window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone) {
      setInstalled(true);
    }
    return () => {
      window.removeEventListener("beforeinstallprompt", onPrompt);
      window.removeEventListener("appinstalled", onInstalled);
    };
  }, []);

  if (installed) return null;

  const isIos = /iphone|ipad|ipod/i.test(window.navigator.userAgent);

  const handle = async () => {
    if (deferred) {
      deferred.prompt();
      await deferred.userChoice;
      setDeferred(null);
    } else {
      setShowHelp(true);
    }
  };

  return (
    <>
      <button
        onClick={handle}
        data-testid="install-app-button"
        className="flex w-full items-center gap-3 px-4 py-3 mb-1 rounded-xl text-sm font-medium text-emerald-300 hover:bg-emerald-500/10 transition-all"
      >
        <Download size={18} /> Pasang Aplikasi
      </button>
      <Dialog open={showHelp} onOpenChange={setShowHelp}>
        <DialogContent>
          <DialogHeader><DialogTitle className="font-heading">Pasang Aplikasi di HP</DialogTitle></DialogHeader>
          <div className="text-sm text-stone-600">
            {isIos ? (
              <ol className="list-decimal list-inside space-y-2">
                <li>Buka situs ini di <b>Safari</b>.</li>
                <li>Ketuk ikon <b>Bagikan</b> (kotak dengan panah ke atas).</li>
                <li>Pilih <b>"Tambahkan ke Layar Utama / Add to Home Screen"</b>.</li>
                <li>Ketuk <b>Tambah</b>. Ikon aplikasi akan muncul di layar HP.</li>
              </ol>
            ) : (
              <ol className="list-decimal list-inside space-y-2">
                <li>Buka di <b>Chrome</b> (Android).</li>
                <li>Ketuk menu <b>⋮</b> (titik tiga) di pojok kanan atas.</li>
                <li>Pilih <b>"Tambahkan ke layar Utama"</b> atau <b>"Install app"</b>.</li>
                <li>Konfirmasi. Ikon aplikasi akan muncul di layar HP seperti aplikasi biasa.</li>
              </ol>
            )}
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}
